import React, { Component } from 'react'
import { withCookies, Cookies } from 'react-cookie'
import WebViewer from '@pdftron/webviewer'

class PDFReader extends Component {
    constructor(props) {
        super(props)

        this.viewer = React.createRef()
        this.docViewer = null
        this.annotManager = null
        this.instance = null
    }

    componentDidMount() {
        if (this.props.url !== '') {
            this.loadPlanWebView(this.props.url)
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const ret = JSON.stringify(this.props.url) !== JSON.stringify(nextProps.url)
        if (ret) {
            this.loadPlanWebView(nextProps.url)
        }
        return false
    }

    loadPlanWebView = (url) => {
        if (this.instance === null) {
            window
                .WebViewer(
                    {
                        path: `${PROXY_HOST}/assets/webviewer`,
                        initialDoc: url,
                        disableLogs: true,
                        disabledElements: ['header', 'toolsHeader'],
                    },
                    this.viewer.current
                )
                .then((instance) => {
                    // at this point, the viewer is 'ready'
                    // call methods from instance, docViewer and annotManager as needed

                    // instance.disableElements(['header']);
                    // instance.disableElements(['viewControlsButton']);
                    // instance.disableElements(['leftPanel']);
                    // instance.disableElements(['searchButton']);
                    // instance.disableElements(['menuButton']);
                    // instance.disableElements(['pageNavOverlay']);

                    this.instance = instance
                    this.docViewer = instance.docViewer
                    this.annotManager = instance.annotManager

                    // you can also access major namespaces from the instance as follows:
                    // var Tools = instance.Tools;
                    // var Annotations = instance.Annotations;

                    // now you can access APIs through `this.instance`
                    // this.instance.openElement('notesPanel');
                    this.instance.setLanguage('ko')
                    // this.instance.disableElements(['stickyToolButton']);
                    // this.annotManager.setCurrentUser(this.state.user);
                    // this.annotManager.setIsAdminUser(true);
                    this.annotManager.setReadOnly(true)

                    // or listen to events from the viewer element
                    this.viewer.current.addEventListener('pageChanged', (e) => {
                        // const [pageNumber] = e.detail;
                        // console.log(`Current page is ${pageNumber}`);
                    })

                    // or from the docViewer instance
                    this.docViewer.on('annotationsLoaded', () => {
                        // console.log('annotations loaded');
                    })
                })
        } else {
            this.instance.loadDocument(url)
        }
    }

    render() {
        return <div className="webviewer" ref={this.viewer} style={{ width: '100%', height: '400px' }}></div>
    }
}

export default withCookies(PDFReader)



// WEBPACK FOOTER //
// ./Src/Components/Commons/PDFReader.js